import axios from "../axiosInstance";
import {
  FetchInvoicePreviewRequest,
  FetchInvoicePreviewResponse,
} from "./types";

export const fetchInvoicePreview = async (
  requestData: FetchInvoicePreviewRequest,
): Promise<FetchInvoicePreviewResponse> => {
  const response = await axios.get<FetchInvoicePreviewResponse>(
    "/api/private/stochastic/campaign-billing/invoice-preview",
    {
      params: requestData,
    },
  );
  return response.data;
};
